import Vue from 'vue'
import Multiselect from 'vue-multiselect'

Multiselect.props.selectLabel.default = ''
Multiselect.props.selectedLabel.default = ''
Multiselect.props.deselectLabel.default = ''
Multiselect.props.maxHeight.default = 300

Vue.component('multiselect', Multiselect)



// WEBPACK FOOTER //
// ./src/config/multiselect.js